// services/orderService.js
import Api from '../utils/api';

const createOrder    = async (data)   => (await Api.post(`/api/orders`, data)).data;
const createAutoOrders = async (threshold = 10) =>
  (await Api.post(`/api/orders/auto?threshold=${threshold}`)).data;
const getOrders      = async (params) => (await Api.get(`/api/orders`, { params })).data;
const getsingleOrder = async (id)     => (await Api.get(`/api/orders/${id}`)).data;
const updateOrder    = async (id, data) => (await Api.put(`/api/orders/${id}`, data)).data;
const deleteOrder    = async (id)     => (await Api.delete(`/api/orders/${id}`)).data;

const orderService = {
  createOrder, createAutoOrders,
  getOrders, getsingleOrder,
  updateOrder, deleteOrder,
};
export default orderService;